module.exports = __webpack_public_path__ + "img/iRentMarket.b11e41cc.png";